import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './system-ai-function.reducer';

export const SystemAiFunctionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const systemAiFunctionEntity = useAppSelector(state => state.systemAiFunction.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="systemAiFunctionDetailsHeading">
          <Translate contentKey="tycheApp.systemAiFunction.detail.title">SystemAiFunction</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{systemAiFunctionEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tycheApp.systemAiFunction.name">Name</Translate>
            </span>
          </dt>
          <dd>{systemAiFunctionEntity.name}</dd>
        </dl>
        <Button tag={Link} to="/system-ai-function" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/system-ai-function/${systemAiFunctionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SystemAiFunctionDetail;
